<template>
  <div class="projects-list">
    <table-component :class-name="'projects-list-table'"
                     :all-checked="allChecked"
                     :column-width="columnWidth"
                     :legend="createLegend()"
                     :clear-checked="clearMarker"
                     :columns="columns"
                     @changeCheckbox="checkedProjects = $event"
                     @filterName="filterName($event)"
                     @filterProject="filterProject($event)"
                     @filterOwner="filterOwner($event)"
                     @checkAll="checkAll"></table-component>
  </div>
</template>

<script>
  import {tableComponentMixin} from "../../../mixins/utils/tableComponentMixin";
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import {filters} from "../../../mixins/filters";

  export default {
    name: 'projectsList',
    props: {
      projects: {
        type: Array
      }
    },
    mixins: [tableComponentMixin, filters],
    data() {
      return {
        nameUp: true,
        nameDown: true,
        nameActive: false,

        projectsUp: true,
        projectsDown: true,
        projectsActive: false,

        ownerUp: true,
        ownerDown: true,
        ownerActive: false,

        legend: [],
        columnWidth: [595/1140 * 100, 150/1140 * 100, 320/1140 * 100, 0],
        clearMarker: false,
      }
    },
    computed: {
      ...mapState({
        checkedProjectsStore: state => state.projects.checkedProjects,
        allRoles: state => state.projects.allRoles
      }),
      ...mapGetters({
        projectOwner: 'projects/projectOwnerRole',
        isAdminRole: 'auth/adminRole',
      }),
      filteredProjects() {
        let arr = [];
        if (this.projects) {
          arr = this.projects.slice();

          if (this.nameActive) {
            arr.sort((a,b) => {
              let nameA = a.name;
              let nameB = b.name

              if (this.nameDown) {
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0
              };
              if (this.nameUp) {
                if (nameA < nameB) return 1;
                if (nameA > nameB) return -1;
                return 0
              }
            })
          };

          if (this.projectsActive) {
            arr.sort((a,b) => {
              let nameA = a.created_at;
              let nameB = b.created_at

              if (this.projectsDown) {
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0
              };
              if (this.projectsUp) {
                if (nameA < nameB) return 1;
                if (nameA > nameB) return -1;
                return 0
              }
            })
          }
        };
        return arr;
      },
      columns() {
        return this.filteredProjects.map(item => {
          return {
            isItemProjects: item.isItemProjects,
            id: item.id,
            item,
            dblClick: item.id,
            dblClickPrefix: '/project/',
            cells: [
              {
                text: {
                  isLink: false,
                  text: item.name,
                  addText: false,
                  isTrimmed: true,
                  // trimWidth: 30
                  trimWidth: 1,
                  addTextData: {
                    text: item.description,
                    isTrimmed: true,
                    // trimWidth: 70
                    trimWidth: 1
                  }
                },
                avatar: {
                  isAvatar: false,
                }
              },
              {
                text: {
                  isLink: false,
                  text: this.timestampToData(item.created_at)
                },
                avatar: {
                  isAvatar: false
                }
              },
              {
                text: {
                  isLink: false,
                  isTrimmed: true,
                  trimWidth: 22,
                  text: this.ownersString(item),

                },
                avatar: {
                  isAvatar: false,
                  avatarLink: this.avatarLink(item)
                }
              },
              {
                isGear: true,
                text: {
                  isLink: true,
                  text: '',
                  linkPrefix: this.notAdminRoleLink(item),
                  link: item.id
                },
                avatar: {
                  isAvatar: false
                }
              }
            ]
          }
        })
      },
      checkedProjects: {
        get() {
          return this.checkedProjectsStore
        },
        set(val) {
          this.setCheckedProjects(val)
        }
      },
      allChecked() {
        return (this.checkedProjectsStore.length === this.projects.length && this.checkedProjectsStore.length > 0)
      }
    },
    watch: {
      checkedProjectsStore(val) {
        if (val.length === 0) {
          this.clearMarker = true;
          setTimeout(() => this.clearMarker = false, 100);
        }
      }
    },
    methods: {
      ...mapMutations({
        setCheckedProjects: 'projects/SET_CHECKED_PROJECTS',
        setIsItemProjects: 'projects/SET_IS_ITEM_PROJECTS'
      }),
      createLegend() {
        return this.legend = [
          {
            text: this.$t('projects.projectsList.nameLb'),
            filterMethod: 'filterName',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: this.$t('projects.projectsList.projectLb'),
            filterMethod: 'filterProject',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: this.$t('projects.projectsList.ownerLb'),
            filterMethod: 'filterOwner',
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false
          },
          {
            text: '',
            legendSort: false,
            isGear: true
          }
        ]
      },
      returnOwners(project) {
        let owners = project.permissions.filter(item => item.value > 3);
        for (let role of this.allRoles) {
          for (let owner of owners) {
            if (role.id == owner.role_id) {
              owner.user = role.user;
              break;
            }
          }
        }

        owners.push(this.ownerRole(project.owner_role_id));

        return owners
      },
      notAdminRoleLink(item) {
        this.setIsItemProjects(item.isItemProjects)
        return '/project/'
      },
      avatarLink(project) {
        if (this.isAdminRole) {
          return this.ownerRole(project.owner_role_id).user.contacts.avatar_url
        } else {
          if (project.owner) {
            //у расшаренных узлов есть поле овнер
            return project.owner.user.contacts.avatar_url
          } else {
            //у расшаренных проектов полностью нету owner, ищем по id в всех ролях
            for (let role of this.allRoles) {
              if (project.owner_role_id) {
                if (project.owner_role_id === role.id) {
                  return role.user.contacts.avatar_url
                }
              }
            }
          }
        }
      },
      ownersString(project) {
        if (this.isAdminRole) {
          let owners = this.returnOwners(project);
          return owners.map(item => {
            if (item.user.first_name) {
              return `${item.user.first_name} ${item.user.second_name ? item.user.second_name : ''}`
            } else {
              return item.user.contacts.email
            }
          }).join(', ')
        } else {
          if (project.owner) {
            //у расшаренных узлов есть поле овнер
            return `${project.owner.user.first_name} ${project.owner.user.second_name ? project.owner.user.second_name : ''}`
          } else {
            //у расшаренных проектов полностью нету owner, ищем по id в всех ролях
            for (let role of this.allRoles) {
              if (project.owner_role_id) {
                if (project.owner_role_id === role.id) {
                  return `${role.user.first_name} ${role.user.second_name ? role.user.second_name : ''}`
                }
              }
            }
          }
        }
      },
      ownerRole(id) {
        return this.projectOwner(id)
      },
      checkAll() {
        if (this.allChecked) {
          this.checkedProjects = []
        } else {
          this.checkedProjects = this.projects
        }
      },
      filterName(index) {
        this.copyLegend();
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.projectsUp = true;
        this.projectsDown = true;
        this.projectsActive = false;

        this.ownerUp = true;
        this.ownerDown = true;
        this.ownerActive = false;

        this.nameActive = true;
        if (this.nameUp && this.nameDown) {
          this.nameDown = true;
          this.nameUp = false;
          this.setLegendDown(index);
          this.setLegendArr()
          return
        };

        if (this.nameUp) {
          this.nameDown = true
          this.nameUp = false;
          this.setLegendDown(index);
          this.setLegendArr()
          return
        }

        if (this.nameDown) {
          this.nameDown = false;
          this.nameUp = true;
          this.setLegendUp(index);
          this.setLegendArr()
          return;
        }
      },
      filterProject(index) {
        this.copyLegend();
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.nameUp = true;
        this.nameDown = true;
        this.nameActive = false;

        this.ownerUp = true;
        this.ownerDown = true;
        this.ownerActive = false;

        this.projectsActive = true;
        if (this.projectsUp && this.projectsDown) {
          this.projectsDown = true;
          this.projectsUp = false;
          this.setLegendDown(index);
          this.setLegendArr()
          return
        };

        if (this.projectsUp) {
          this.projectsDown = true
          this.projectsUp = false;
          this.setLegendDown(index);
          this.setLegendArr()
          return
        }

        if (this.projectsDown) {
          this.projectsDown = false;
          this.projectsUp = true;
          this.setLegendUp(index);
          this.setLegendArr()
          return;
        }
      },
      filterOwner(index) {

      }
    }
  }
</script>

<style lang="scss" scoped>
  .projects-list {
    padding: 20px 30px 0;
  }
</style>
